<div class="ui modal advanced-filtering">
  <div class="ui header">Filters</div>

  <div class="content">
    <query-filters
      [datasetName]="datasetName"
      [schema]="schema"
      [filters]="filters"
      [filterOptions]="queryFilterOptions"
      [options]="queryOptions"
      [interval]="interval"
      [showDefaultFilter]="true"
      [externalFilterSources]="globalSelectedFilterSources"
      [firstDayOfWeek]="query.firstDayOfWeek"
      (filtersData)="updateFilters($event)"
    ></query-filters>

    <ng-container *ngIf="globalFilters.length">
      <hr class="spacer">
      <div class="ui accordion">
        <div class="ui header title" [domWatch]="{attributes: true, attributeFilter:['class']}" (dom-mutation)="trackFilterOpen(false, $event)">
          <i class="dropdown icon"></i>
          Global Filters
        </div>
        <div class="content">
          <query-filters
            [datasetName]="datasetName"
            [schema]="schema"
            [filters]="globalFilters"
            [filterOptions]="globalFilterOptions"
            [options]="globalOptions"
            [interval]="interval"
            [readonly]="true"
            [externalFilterSources]="querySelectedFilterSources"
            [firstDayOfWeek]="query.firstDayOfWeek"
          ></query-filters>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="pageSpecificFilters.length">
      <hr class="spacer">
      <div class="ui accordion">
        <div class="ui header title" [domWatch]="{attributes: true, attributeFilter:['class']}" (dom-mutation)="trackFilterOpen(true, $event)">
          <i class="dropdown icon"></i>
          Page-Specific Filters
        </div>
        <div class="content">
          <query-filters
            [datasetName]="datasetName"
            [schema]="schema"
            [filters]="pageSpecificFilters"
            [filterOptions]="globalFilterOptions"
            [options]="globalOptions"
            [interval]="interval"
            [readonly]="true"
            [externalFilterSources]="querySelectedFilterSources"
            [firstDayOfWeek]="query.firstDayOfWeek"
          ></query-filters>
        </div>
      </div>
    </ng-container>

  </div>
  <div class="tw-p-4 tw-flex tw-justify-end tw-gap-4 button-container">
    <p-button
      label="Cancel"
      severity="secondary"
      (click)="cancel()"
    ></p-button>

    <div
      [pTooltip]="emptyFilterTypeExists ? 'One or more filter types are missing' : null"
      tooltipPosition="top"
    >
      <p-button
        label="Add Filter {{ hasMetrics ? ' and Run Query' : '' }}"
        [disabled]="emptyFilterTypeExists"
        (onClick)="applyFilters()"
      ></p-button>
    </div>
  </div>
</div>
